(() => {

  if (customElements.get('casemiri-home')) return;



  class CasemiriHome extends HTMLElement {

    connectedCallback() {

      if (this.isConnectedAndReady) return;

      this.isConnectedAndReady = true;



      /*
       * Correzione dedicata al browser interno
       * di Instagram su smartphone.
       */

      this.isInstagramMobile =
        /Instagram/i.test(navigator.userAgent) &&
        window.matchMedia('(max-width: 749px)').matches;



      if (this.isInstagramMobile) {

        this.classList.add('is-instagram-browser');

        this.lockInstagramViewport();



        this.onOrientationChange = () => {

          window.clearTimeout(this.instagramOrientationTimer);



          this.instagramOrientationTimer = window.setTimeout(() => {

            this.lockInstagramViewport();

          }, 300);

        };



        window.addEventListener(
          'orientationchange',
          this.onOrientationChange
        );

      }



      this.slides = Array.from(
        this.querySelectorAll('[data-casemiri-hero-slide]')
      );



      this.previousButton = this.querySelector('[data-casemiri-prev]');

      this.nextButton = this.querySelector('[data-casemiri-next]');

      this.currentLabel = this.querySelector('[data-casemiri-current]');

      this.progress = this.querySelector('[data-casemiri-progress]');

      this.hero = this.querySelector('[data-casemiri-hero]');



      this.activeIndex = Math.max(
        0,
        this.slides.findIndex((slide) =>
          slide.classList.contains('is-active')
        )
      );



      this.autoplayEnabled = this.dataset.autoplay === 'true';



      this.autoplaySpeed = Math.max(
        3000,
        Number(this.dataset.autoplaySpeed) || 7000
      );



      this.prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;



      this.pointerStartX = null;



      this.onPrevious = () => {
        this.goTo(this.activeIndex - 1, true);
      };



      this.onNext = () => {
        this.goTo(this.activeIndex + 1, true);
      };



      this.onPointerDown = (event) => {

        if (event.pointerType === 'mouse') return;

        this.pointerStartX = event.clientX;

      };



      this.onPointerUp = (event) => {

        if (this.pointerStartX === null) return;



        const movement = event.clientX - this.pointerStartX;

        this.pointerStartX = null;



        if (Math.abs(movement) < 45) return;



        movement < 0
          ? this.onNext()
          : this.onPrevious();

      };



      this.onVisibilityChange = () => {

        document.hidden
          ? this.stopAutoplay()
          : this.startAutoplay();

      };



      this.onHeroEnter = () => {

        this.stopAutoplay();

      };



      this.onHeroLeave = () => {

        this.startAutoplay();

      };



      this.onHeroFocusIn = () => {

        this.stopAutoplay();

      };



      this.onHeroFocusOut = () => {

        this.startAutoplay();

      };



      this.onShopifyBlockSelect = (event) => {

        const slide = event.target.closest(
          '[data-casemiri-hero-slide]'
        );



        if (!slide) return;



        const index = this.slides.indexOf(slide);



        if (index >= 0) {

          this.goTo(index, false);

        }



        this.stopAutoplay();

      };



      this.previousButton?.addEventListener(
        'click',
        this.onPrevious
      );



      this.nextButton?.addEventListener(
        'click',
        this.onNext
      );



      this.hero?.addEventListener(
        'pointerdown',
        this.onPointerDown,
        { passive: true }
      );



      this.hero?.addEventListener(
        'pointerup',
        this.onPointerUp,
        { passive: true }
      );



      this.hero?.addEventListener(
        'mouseenter',
        this.onHeroEnter
      );



      this.hero?.addEventListener(
        'mouseleave',
        this.onHeroLeave
      );



      this.hero?.addEventListener(
        'focusin',
        this.onHeroFocusIn
      );



      this.hero?.addEventListener(
        'focusout',
        this.onHeroFocusOut
      );



      document.addEventListener(
        'visibilitychange',
        this.onVisibilityChange
      );



      this.addEventListener(
        'shopify:block:select',
        this.onShopifyBlockSelect
      );



      this.render();

      this.initReveal();

      this.startAutoplay();

    }



    disconnectedCallback() {

      this.stopAutoplay();

      this.revealObserver?.disconnect();



      this.previousButton?.removeEventListener(
        'click',
        this.onPrevious
      );



      this.nextButton?.removeEventListener(
        'click',
        this.onNext
      );



      this.hero?.removeEventListener(
        'pointerdown',
        this.onPointerDown
      );



      this.hero?.removeEventListener(
        'pointerup',
        this.onPointerUp
      );



      this.hero?.removeEventListener(
        'mouseenter',
        this.onHeroEnter
      );



      this.hero?.removeEventListener(
        'mouseleave',
        this.onHeroLeave
      );



      this.hero?.removeEventListener(
        'focusin',
        this.onHeroFocusIn
      );



      this.hero?.removeEventListener(
        'focusout',
        this.onHeroFocusOut
      );



      document.removeEventListener(
        'visibilitychange',
        this.onVisibilityChange
      );



      this.removeEventListener(
        'shopify:block:select',
        this.onShopifyBlockSelect
      );



      if (this.onOrientationChange) {

        window.removeEventListener(
          'orientationchange',
          this.onOrientationChange
        );

      }



      window.clearTimeout(this.instagramOrientationTimer);



      this.isConnectedAndReady = false;

    }



    lockInstagramViewport() {

      const viewportHeight = Math.round(window.innerHeight);



      this.style.setProperty(
        '--casemiri-instagram-viewport',
        `${viewportHeight}px`
      );



      this.style.setProperty(
        '--casemiri-instagram-focus',
        `${Math.round(viewportHeight * 0.76)}px`
      );



      this.style.setProperty(
        '--casemiri-instagram-manifesto',
        `${Math.round(viewportHeight * 0.56)}px`
      );



      this.style.setProperty(
        '--casemiri-instagram-world',
        `${Math.round(viewportHeight * 0.54)}px`
      );

    }



    goTo(index, restartAutoplay = false) {

      if (this.slides.length < 2) return;



      this.activeIndex =
        (index + this.slides.length) % this.slides.length;



      this.render();



      if (restartAutoplay) {

        this.stopAutoplay();

        this.startAutoplay();

      }

    }



    render() {

      this.slides.forEach((slide, index) => {

        const isActive = index === this.activeIndex;



        slide.classList.toggle(
          'is-active',
          isActive
        );



        slide.setAttribute(
          'aria-hidden',
          String(!isActive)
        );



        slide.toggleAttribute(
          'inert',
          !isActive
        );

      });



      if (this.currentLabel) {

        this.currentLabel.textContent = String(
          this.activeIndex + 1
        ).padStart(2, '0');

      }



      if (this.progress && this.slides.length) {

        this.progress.style.width =
          `${((this.activeIndex + 1) / this.slides.length) * 100}%`;

      }

    }



    startAutoplay() {

      if (
        !this.autoplayEnabled ||
        this.prefersReducedMotion ||
        document.hidden ||
        this.slides.length < 2
      ) {
        return;
      }



      this.stopAutoplay();



      this.autoplayTimer = window.setInterval(() => {

        this.goTo(this.activeIndex + 1);

      }, this.autoplaySpeed);

    }



    stopAutoplay() {

      if (!this.autoplayTimer) return;



      window.clearInterval(this.autoplayTimer);

      this.autoplayTimer = null;

    }



    initReveal() {

      const elements = Array.from(
        this.querySelectorAll('[data-casemiri-reveal]')
      );



      if (!elements.length) return;



      if (
        this.dataset.reveal !== 'true' ||
        this.prefersReducedMotion ||
        !('IntersectionObserver' in window)
      ) {

        elements.forEach((element) => {

          element.classList.add('is-visible');

        });



        return;

      }



      this.revealObserver = new IntersectionObserver(
        (entries, observer) => {

          entries.forEach((entry) => {

            if (!entry.isIntersecting) return;



            entry.target.classList.add('is-visible');

            observer.unobserve(entry.target);

          });

        },
        {
          rootMargin: '0px 0px -8% 0px',
          threshold: 0.08
        }
      );



      elements.forEach((element) => {

        this.revealObserver.observe(element);

      });

    }

  }



  customElements.define(
    'casemiri-home',
    CasemiriHome
  );

})();